import { Row } from "./Row";
interface IProsp {
  isShow: boolean;
  onToggle: () => void;
}

export const UseByChildren = ({ onToggle, isShow }: IProsp) => {
  return (
    <Row title="Use by Children" onToggle={onToggle} isShow={isShow}>
      <div className="font-bold pb-2">a. Marketing and Sales to Adults</div>
      We provide our mobile applications to and manage online accounts for
      adults 18 years and older. We do not market or sell products or services
      to children or knowingly collect personal information from children for
      purposes of marketing or sales. If you believe that we have unknowingly
      collected information about a minor in connection with our marketing or
      sales operations, please write to us using one of the methods in Section
      11 (Contacting Us) below in order for us to delete it.
      <div className="mt-4">
        <div className="font-bold pb-2">
          b. Personal Information of Children Collected in Connection with the
          Use of Smart Devices
        </div>
        Although we provide our mobile applications and managed online services
        to adults, we recognize that family and household members of purchasers
        using our product partners’ smart devices may be children. Online
        accounts maintained by Medcursor used by adult purchasers of smart devices
        to rediv personal information collected via these products may include
        personal information of purchasers’ family and household members who are
        children.
        <div className="mt-4">
          We are committed to using special safeguards to the protecting the
          privacy of personal information collected about children. While all
          Medcursor accounts must be controlled by adults using a Medcursor mobile
          application, parents or guardians of a child may allow the child to
          use product partners’ smart scale and other fitness products and
          configure their Medcursor accounts to track fitness data about the
          child. Parents or guardians may also add a child’s name, weight, age,
          and birthday into their Medcursor accounts used with smart scale and
          other fitness products. Note that we do not ask a child to supply any
          information to us directly. Rather, a parent or guardian consents to
          the collection of personal information and may supply some personal
          information about a child. After that, a smart scale or other fitness
          product’s sensors collect personal data from the child in connection
          with the child’s use of the product.
        </div>
        <div className="mt-4">
          This section describes the following aspects of personal information
          collected from children in connection with the use of a Medcursor app to
          manage product partners’ smart devices and the personal information
          associated with them:
        </div>
        <ul className="list-disc pl-8 mt-2 text-gray666 dark:text-white60">
          <li>The types of personal information collected</li>
          <li>How Medcursor collects that personal information</li>
          <li>Uses of the collected personal information</li>
          <li>
            The disclosure and sharing of personal information with third
            parties and the role of third parties in maintaining the personal
            information
          </li>
          <li>
            A description of the rights of parents and guardians with respect to
            personal information collected from their children
          </li>
          <li>How parents and guardians can exercise their rights</li>
        </ul>
        <div className="pl-6">
          <div className="font-bold mt-4">
            i. Types of Personal Information Collected from Children
          </div>
          <div className="pt-2">
            Our product partners‘ smart devices may collect personal
            information, such as weight, blood pressure, and fitness
            information, when children use them. Medcursor online accounts may
            include a child’s name associated with personal information
            collected by smart devices.
          </div>
          <div className="font-bold mt-4">
            ii. How Product Partners and Medcursor Collect Personal Information
            from Children
          </div>
          <div className="pt-2">
            Our product partners’ smart devices that collect personal
            information use sensors to collect the information. When children
            are using these smart devices, Medcursor receives, stores, and
            maintains their personal information. Users may div and manage the
            collected personal information using a Medcursor online account
            accessed via a Medcursor mobile application.
          </div>
          <div className="mt-4">
            Medcursor may also collect personal information about children (such
            as the child’s name) when parents or guardians provide us the
            information using their online accounts accessed via a Medcursor
            mobile application.
          </div>
          <div className="mt-4">
            Medcursor will obtain verifiable consent before collecting personal
            information about children. For instance, when a parent or guardian
            adds a child to an online account, the parent or guardian must
            consent to the collection of personal information about the child. A
            parent or guardian must rediv the Notice and Consent to Medcursor’s
            Collection, Use, and Disclosure of Your Child’s Information before
            Medcursor will obtain personal information about a child.
          </div>

          <div className="font-bold mt-4">
            iii. Uses of Personal Information Collected from Children
          </div>
          <div className="pt-2">
            Medcursor uses personal information we collect from children for the
            purpose of providing, maintaining, and supporting its services to
            allow users to div and manage the collected personal information
            using a Medcursor online account.
          </div>

          <div className="font-bold mt-4">
            iv. Third Party Disclosure, Sharing, and Maintenance
          </div>
          <div className="pt-2">
            Our policies and practices concerning third party personal
            information sharing, disclosure, and maintenance are described below
            in Section 6.
          </div>

          <div className="font-bold mt-4">
            v. Retention of Children's Personal Information
          </div>
          <div className="pt-2">
            Our policies and practices concerning retention of personal
            information are described below in Section 5(e).
          </div>

          <div className="font-bold mt-4">
            vi. Parents' and Guardians' Rights with Respect to Their Children's
            Personal Information
          </div>
          <div className="pt-2">
            Parents and guardians have the following rights under this policy
            with respect to their children's personal information:
            <ul className="list-disc pl-8 mt-2 text-gray666 dark:text-white60">
              <li>
                Parents and guardians are entitled to div, correct, or update
                the personal information of their children, except as noted
                below.
              </li>
              <li>
                Although we do not sell or share personal information of
                children or any other users in the ordinary course of business,
                as described in more detail in Section 6, a parent or guardian
                is entitled to opt out of further personal information
                collection, maintenance by third parties, or sharing outside the
                ordinary course of business by deleting information about the
                child, as described in Section 3(b)(vii).
              </li>
              <li>
                Parents and guardians are entitled to delete personal
                information about a child as described in Section 3(b)(vii).
              </li>
            </ul>
            <div className="mt-4">
              If you revoke permission to collect a child's data or delete a
              child's data, your child will not be able to use the functionality
              of our product partners' smart devices.
            </div>
            <div className="mt-4">
              Please keep in mind that in unusual circumstances we may have a
              legal right or obligation to preserve a child's personal
              information as it currently exists. If we do not amend or delete
              personal information about your child upon your request, we will
              communicate with you concerning the reason.
            </div>
          </div>

          <div className="font-bold mt-4">
            vii. How Parents and Guardians Can Exercise Their Rights
          </div>
          <div>
            If you are a parent or guardian and would like to exercise any of
            the rights described in Section 3(b)(vii), as a Medcursor mobile
            application user, you have the ability to log into a Medcursor mobile
            application and make corrections to or delete the personal
            information about your children in your account profile.
            Alternatively, or if you need assistance, please contact us by one
            if the means described in Section 11, and someone on our support
            team will assist you correct, update, or delete your child’s
            personal information.
          </div>
          <div className="mt-4">
            When a parent or guardian seeks to exercise any of the rights in
            Section 3(b)(vi), we will verify the identity of the parent or
            guardian. See Section 9(b) for identity verification details.
          </div>
        </div>
      </div>
      <div className="font-bold mt-4">
        c. Other Collection of Personal Information from Children
      </div>
      <div className="mt-4">
        Except as noted above in this Section 3, we do not provide applications,
        services, or products to children, and we do not knowingly collect
        personal information from children.
      </div>
      <div className="mt-4">
        Should a parent or guardian have reasons to believe that a minor has
        provided Medcursor with personal information without prior consent or that
        we have collected personal information about a minor in a way not
        permitted in this Section 3, please contact us to ensure that the
        personal information is removed using the contact information in Section
        11. Also, please contact us if you have any questions or concerns about
        our collection and management of children’s personal information.
      </div>
    </Row>
  );
};
